import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { useToast } from "@/components/ui/use-toast";
import { useUser } from "@/contexts/user-provider";
import useCopyToClipboard from "@/hooks/useCopyToClipboard";
import { useTranslation } from "@/hooks/useTranslation";
import { CopyIcon } from "lucide-react";

export const CardReferralLink = () => {
  const { t } = useTranslation();
  const { user } = useUser();
  const { toast } = useToast();
  const [, copy] = useCopyToClipboard();

  return (
    <Card className="flex flex-col flex-1 justify-between">
      <CardHeader>
        <CardTitle>{t("referrals.referralLink.title")}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col flex-1 justify-between">
        <div className="mb-4 text-sm text-muted-foreground">
          {t("referrals.referralLink.description")}
        </div>
        <div className="flex items-center mt-auto space-x-2 w-full">
          <Input
            id="referral-url"
            type="text"
            value={`${import.meta.env.VITE_WEBSITE_BASE_URL}/r/${
              user?.referralCode
            }`}
            readOnly
            className="flex-1"
          />
          <Button
            type="button"
            size="sm"
            className="px-3"
            onClick={async () => {
              const success = await copy(
                `${import.meta.env.VITE_WEBSITE_BASE_URL}/r/${
                  user?.referralCode
                }`
              );
              if (success) {
                toast({
                  variant: "default",
                  title: t("referrals.referralLink.copied.title"),
                  description: t("referrals.referralLink.copied.description"),
                });
              }
            }}
          >
            <CopyIcon className="w-4 h-4" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
